module.exports = __webpack_public_path__ + "media/styles/images/png/upload-overlay-teal-fc662d5726f23a2d6a442b1039a2d488.png";